var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.model
      ? _c(
          "div",
          [
            _vm.isFinalReport
              ? _c(
                  "div",
                  [
                    _c("h3", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("InvestmentReport.Finances.Funding.Title")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("lines-and-details", {
                      attrs: {
                        id: "funding",
                        value: _vm.funding,
                        required: true,
                        showColumnTotals: true
                      }
                    }),
                    _vm._v(" "),
                    _vm.showSelfCoveredFundingLoanCondition
                      ? _c("radio-button-option-row", {
                          attrs: {
                            title:
                              "InvestmentReport.Finances.Funding.SelfCoveredFundingLoanCondition",
                            required: false,
                            options: _vm.optionsArray("PledgeType", true)
                          },
                          model: {
                            value:
                              _vm.model.funding.selfCoveredFundingLoanCondition,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.model.funding,
                                "selfCoveredFundingLoanCondition",
                                $$v
                              )
                            },
                            expression:
                              "model.funding.selfCoveredFundingLoanCondition"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("InvestmentReport.Finances.Expenses.Title")))
            ]),
            _vm._v(" "),
            _vm.isFinalReport
              ? _c("personnel-expenses", {
                  attrs: {
                    value: _vm.personnelExpenses,
                    features: _vm.features
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("lines-and-details", {
              attrs: {
                id: "expense-breakdown",
                value: _vm.expenseBreakdown,
                required: true,
                showColumnTotals: true
              },
              scopedSlots: _vm._u(
                [
                  !_vm.isFinalReport
                    ? {
                        key: "totalIndicator",
                        fn: function() {
                          return [
                            _c("ValidationProvider", {
                              attrs: {
                                name: "totalIndicator",
                                rules: { min_value: 1 },
                                slim: ""
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      var failedRules = ref.failedRules
                                      return [
                                        _vm.hasErrors(failedRules)
                                          ? _c(
                                              "span",
                                              { staticClass: "warning-text" },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "tooltip",
                                                        rawName:
                                                          "v-tooltip.top.center",
                                                        value: {
                                                          html: true,
                                                          content: _vm.$t(
                                                            "Validation.ComputedAmountIsZero"
                                                          )
                                                        },
                                                        expression:
                                                          "{ html: true, content: $t('Validation.ComputedAmountIsZero') }",
                                                        modifiers: {
                                                          top: true,
                                                          center: true
                                                        }
                                                      }
                                                    ],
                                                    staticClass:
                                                      "fas fa-exclamation-triangle icon",
                                                    attrs: { tabindex: "0" }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "sr-only"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "Validation.ComputedAmountIsZero"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("input", {
                                          staticClass: "sr-only d-none",
                                          attrs: {
                                            "aria-hidden": "true",
                                            "aria-label":
                                              "this is hidden from screen reader"
                                          },
                                          domProps: {
                                            value:
                                              _vm.expenseBreakdown.grandTotal
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3607971778
                              )
                            })
                          ]
                        },
                        proxy: true
                      }
                    : null
                ],
                null,
                true
              )
            }),
            _vm._v(" "),
            _vm.isFinalReport
              ? _c(
                  "div",
                  [
                    _c(
                      "h3",
                      [
                        _c("plain-text-control", {
                          attrs: {
                            title: "InvestmentReport.Finances.Results.Title"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("lines-and-details", {
                      attrs: {
                        id: "results",
                        value: _vm.results,
                        showColumnTotals: true
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "indicator",
                            fn: function(slotProps) {
                              return [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.$t(slotProps.title)) +
                                    "\n          "
                                ),
                                _vm.showNoExpensesError(slotProps.line)
                                  ? _c(
                                      "span",
                                      { staticClass: "warning-text" },
                                      [
                                        _c(
                                          "i",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip.top.center",
                                                value: {
                                                  html: true,
                                                  content: _vm.$t(
                                                    "Validation.ComputedAmountIsZero"
                                                  )
                                                },
                                                expression:
                                                  "{ html: true, content: $t('Validation.ComputedAmountIsZero') }",
                                                modifiers: {
                                                  top: true,
                                                  center: true
                                                }
                                              }
                                            ],
                                            staticClass:
                                              "fas fa-exclamation-triangle icon",
                                            attrs: { tabindex: "0" }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "sr-only" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Validation.ComputedAmountIsZero"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        969174570
                      )
                    }),
                    _vm._v(" "),
                    _c("h3", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "InvestmentReport.Finances.Premises.Area.Title"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("premises", {
                      attrs: {
                        id: "premises",
                        title:
                          "InvestmentReport.Finances.Premises.Area.TableTitle",
                        value: _vm.premises.items,
                        required: true,
                        columnKeys: _vm.premises.columnKeys
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("h3", [
              _vm._v(
                _vm._s(_vm.$t("InvestmentReport.Finances.Attachments.Title"))
              )
            ]),
            _vm._v(" "),
            _c("attachments", {
              attrs: { showActions: true },
              model: {
                value: _vm.attachments,
                callback: function($$v) {
                  _vm.attachments = $$v
                },
                expression: "attachments"
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }